import genreFrameOne from "@images/genres/Frame 2085663667.png";
import genreFrameTwo from "@images/genres/Frame 2085663667-1.png";
import genreFrameThree from "@images/genres/Frame 2085663667-2.png";
import genreFrameFour from "@images/genres/Frame 2085663667-3.png";
import genreFrameFive from "@images/genres/Frame 2085663667-4.png";
import genreFrameSix from "@images/genres/Frame 2085663667-5.png";

export const HERO_SLIDES = [
  {
    id: 1,
    img: "https://image.tmdb.org/t/p/original/pT8IMXnuJ17NzbQlBSIW2mn5JJO.jpg",
    logo: "https://image.tmdb.org/t/p/original/fPqErt1rgFoggWE08kvump16frk.png",
    title: "Аватар",
  },
  {
    id: 2,
    img: "https://image.tmdb.org/t/p/original/7w165QdHmJuTHSQwEyJDBDpuDT7.jpg",
    logo: "https://image.tmdb.org/t/p/original/p14VPAvBTkk5ogZ9Z31UaCNaBm6.png",
    title: "Побег",
  },
  {
    id: 3,
    img: "https://image.tmdb.org/t/p/original/arIrVsIzufF5iY7nTSwWnjO6uRq.jpg",
    logo: "https://image.tmdb.org/t/p/original/j9ziUW1XxlmUp5YUK2Ez5gtpyS.png",
    title: "Премьера",
  },
  {
    id: 4,
    img: "https://image.tmdb.org/t/p/original/6gN8DYnIEln8v7OhRy61c57w0Xy.jpg",
    logo: "https://image.tmdb.org/t/p/original/8ROOhzM7Qgj5vD64zf6EHoMyf1N.png",
    title: "Извне",
  },
];

export const CONTINUE_WATCHING = [
  {
    id: 1,
    title: "Аватар",
    duration: "2 ч 3 мин",
    progress: 42,
    img: "https://image.tmdb.org/t/p/original/Yc9q6QuWrMp9nuDm5R8ExNqbEq.jpg",
  },
  {
    id: 2,
    title: "Иллюзия обмана 3",
    duration: "2 ч 3 мин",
    progress: 62,
    img: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=400&q=70",
  },
  {
    id: 3,
    title: "Плохие парни 2",
    duration: "2 ч 3 мин",
    progress: 25,
    img: "https://images.unsplash.com/photo-1509347528160-9a9e33742cdb?w=400&q=70",
  },
  {
    id: 4,
    title: "Достать ножи: Воскрешение",
    duration: "2 ч 3 мин",
    progress: 80,
    img: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=400&q=70",
  },
  {
    id: 5,
    title: "Джуманджи: Новый уровень",
    duration: "2 ч 3 мин",
    progress: 16,
    img: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=400&q=70",
  },
  {
    id: 6,
    title: "Аватар",
    duration: "2 ч 3 мин",
    progress: 55,
    img: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=400&q=70",
  },
  {
    id: 7,
    title: "Зверополис 2",
    duration: "1 ч 58 мин",
    progress: 33,
    img: "https://images.unsplash.com/photo-1507924538820-ede94a04019d?w=400&q=70",
  },
];

export const NEW_IN_SUBSCRIPTION = [
  {
    id: 1,
    title: "Аватар: Пламя и пепел",
    year: "2021",
    type: "Фильм",
    rating: "9,0",
    bg: "#1a3a5c",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/kpxYvaCnbRi7btNnpLCJrehy77e.jpg",
  },
  {
    id: 2,
    title: "Одна из многих",
    year: "2021",
    type: "Фильм",
    rating: "4,3",
    bg: "#c9a020",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/ogBuIahJawmheKqrc7F7gRXmpU0.jpg",
  },
  {
    id: 3,
    title: "Зверопой 2",
    year: "2021",
    type: "Фильм",
    rating: "2,4",
    bg: "#1c5c30",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/cYWc9bCi2gprrXnIMa4MqXUTpNu.jpg",
  },
  {
    id: 4,
    title: "Пять ночей с Фредди 2",
    year: "2021",
    type: "Фильм",
    rating: "9,0",
    bg: "#1a1a2e",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/geZhhgqqMrOQdhm4Kv9ulxPI5ZN.jpg",
  },
  {
    id: 5,
    title: "Фоллаут",
    year: "2021",
    type: "Фильм",
    rating: "9,0",
    bg: "#243a0f",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/7o3XRf31lEtAaRNtgupOGTDD3sP.jpg",
  },
  {
    id: 6,
    title: "Достать ножи: Воскрешение",
    year: "2021",
    type: "Фильм",
    rating: "9,0",
    bg: "#1c1c1c",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/rffS3bS0shNAhsgCoXtJJOIEl70.jpg",
  },
  {
    id: 7,
    title: "Джуманджи: Новый уровень",
    year: "2021",
    type: "Фильм",
    rating: "9,0",
    bg: "#3a1c1c",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/eEjh9ljWHGLg8jrvgzNJxRrqQVK.jpg",
  },
];

export const COMING_SOON = [
  {
    id: 1,
    title: "Очень странные дела",
    year: "2021",
    type: "Фильм",
    date: "29",
    month: "АПРЕЛЯ",
    img: "https://image.tmdb.org/t/p/original/hTWtybOC91veCgHAVt3ULZnj4up.jpg",
    logo: "https://image.tmdb.org/t/p/original/bEwnnnFg9WOOKtXxc3eRu2SjqPb.png",
  },
  {
    id: 2,
    title: "Пять ночей с Фредди 2",
    year: "2021",
    type: "Фильм",
    date: "10",
    month: "СЕНТЯБРЯ",
    img: "https://image.tmdb.org/t/p/original/jVOFaJx0TecMlGHzbAc9sHDgOXg.jpg",
    logo: "https://image.tmdb.org/t/p/original/gnvnP21YRkpT8VXgptyIvmyoqsJ.png",
  },
  {
    id: 3,
    title: "Очень странные дела",
    year: "2021",
    type: "Фильм",
    date: "1",
    month: "ЯНВАРЯ",
    img: "https://image.tmdb.org/t/p/original/q3UGWifvIpdey1T2efX4dSmbZpU.jpg",
    logo: "https://image.tmdb.org/t/p/original/8ROOhzM7Qgj5vD64zf6EHoMyf1N.png",
  },
  {
    id: 4,
    title: "Очень странные дела",
    year: "2021",
    type: "Фильм",
    date: "31",
    month: "ДЕКАБРЯ",
    img: "https://image.tmdb.org/t/p/original/2I1OFQJ0L9T0dpU6FobKFWV2PxX.jpg",
    logo: "https://image.tmdb.org/t/p/original/wMeHGUBczNepQQmbj9Wr8y8qWA5.png",
  },
];

export const TOP_7 = [
  {
    title: "Очень странные дела",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/jucD9FzLjVsFfBiFcSdoLa6rPOl.jpg",
  },
  {
    title: "Интерстеллар",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/4eqr5LZH122BiU9hboXHZxX8bBl.jpg",
  },
  {
    title: "Бесстыжие",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/pVJzfWgb3sHN29hLaiI5jmBN9vx.jpg",
  },
  {
    title: "Друзья",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/qNABFhduyxg5gvzFuuSPFRh2uls.jpg",
  },
  {
    title: "Во все тяжкие",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/hXoGcvNOeWZkxbaitu7ZvEM0hQJ.jpg",
  },
  {
    title: "Побег",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/5E1BhkCgjLBlqx557Z5yzcN0i88.jpg",
  },
  {
    title: "Аватар",
    img: "https://www.themoviedb.org/t/p/w600_and_h900_face/kpxYvaCnbRi7btNnpLCJrehy77e.jpg",
  },
];

export const GENRES = [
  {
    id: 1,
    title: "Комедии",
    image: genreFrameOne,
  },
  {
    id: 2,
    title: "Боевики",
    image: genreFrameTwo,
  },
  {
    id: 3,
    title: "Комедии",
    image: genreFrameThree,
  },
  {
    id: 4,
    title: "Драмы",
    image: genreFrameFour,
  },
  {
    id: 5,
    title: "Фантастика",
    image: genreFrameFive,
  },
  {
    id: 6,
    title: "Триллеры",
    image: genreFrameSix,
  },
];
